module.exports = __webpack_public_path__ + "63c9fd342c719f205a7ba3938414abc9.svg";